query allBaseballTeams(
  $first: Int,
  $offset: Int,
  $filter: BaseballTeamFilter,
  ) {
  teams: allBaseballTeams(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
        squad
        shortName
        name
        source
        teamId
        division
        stadium
        city
        state
        mappings: baseballTeamMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingType
        }
      }
    }
    totalCount
  }
}
